import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"
import { isEmpty } from "lodash"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Activity from "./Activity"
import Overview from "./Overview"
import RepairComments from "./RepairComments"
import { useLoading, useUnreadRepairRequestsCount } from "helpers/custom_hooks"
import { GetMyUser, GetRepairRequestByID } from "helpers/backend_helper"
import { useNavigate, useParams } from "react-router-dom"
import { updateUnreadRepairRequests } from "helpers/misc_helpers"
import RepairRatingModal from "./RepairRatingModal"

const RepairOverview = props => {
  const [entry, setEntry] = useState()
  const [myUser, setMyUser] = useState()
  const navigate = useNavigate()
  const [_, setUnreadRepairRequestsCount] = useUnreadRepairRequestsCount()
  const setLoading = useLoading()
  let { id } = useParams()

  const loadData = async () => {
    setLoading(true)
    try {
      const result = await GetRepairRequestByID(id)
      const user = await GetMyUser()
      setMyUser(user)

      setEntry(result)
    } catch (error) {
      console.log(error)
      if (error.response.status === 404) navigate("/404")
      else alert("An unexpected error happened!")
    }
    setLoading(false)

    setTimeout(() => {
      updateUnreadRepairRequests(setUnreadRepairRequestsCount)
    }, 1000)
  }

  useEffect(() => {
    loadData()
  }, [id])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Details" breadcrumbItem="Repair Request" />

          {!isEmpty(entry) && (
            <>
              <Row>
                <Col lg="4">
                  <Overview entry={entry} printBtn />
                </Col>
                <Col lg="4">
                  <Activity entry={entry} myUser={myUser} reload={loadData} />
                </Col>
                <Col lg="4">
                  <RepairComments entry={entry} reload={loadData} />
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>

      <RepairRatingModal entry={entry} myUser={myUser} />
    </React.Fragment>
  )
}

RepairOverview.propTypes = {
  match: PropTypes.object,
}

export default withRouter(RepairOverview)
